
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"62","viewBox":"0 0 62 62","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"gst-svg-icon-progress-circle-stroke-underlay",attrs:{"cx":"31","cy":"31","r":"29","fill":"none","stroke":"#EBEBEB","stroke-width":"4"}}),_c('circle',{staticClass:"gst-svg-icon-progress-circle-stroke-overlay-left",attrs:{"cx":"31","cy":"31","r":"29","fill":"none","stroke":"#23262D","stroke-width":"4"}}),_c('circle',{staticClass:"gst-svg-icon-progress-circle-stroke-overlay-right",attrs:{"cx":"31","cy":"31","r":"29","fill":"none","stroke":"#23262D","stroke-width":"4"}}),_c('path',{staticClass:"gst-svg-icon-progress-circle-checkmark",attrs:{"d":"M27.712 47.29L13.435 32.98l6.18-6.215 8.086 8.14 17.112-17.138 6.19 6.2L27.713 47.29z","fill":"#23262D"}})])
          )
        }
      }
    